// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xc_banner[data-v-28e6ccac]{position:relative;overflow:hidden}.xc_banner .intro[data-v-28e6ccac]{position:absolute;top:50%;transform:translateY(-50%);left:0;width:100%}.xc_banner .intro .tit[data-v-28e6ccac]{font-size:36px;line-height:40px;font-weight:700;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
